import { Button } from '@repo/ui/components'
import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/error')({
  component: ErrorPage,
})

function ErrorPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16 text-center">
      <h1 className="text-4xl font-bold">500</h1>
      <h2 className="text-xl font-semibold">Something Went Wrong</h2>
      <p className="max-w-md text-muted-foreground">
        An unexpected error occurred. Please try again later.
      </p>
      <div className="flex gap-2">
        <Button asChild variant="outline">
          <Link to="/">Go Home</Link>
        </Button>
        <Button onPress={() => window.location.reload()}>Try Again</Button>
      </div>
    </div>
  )
}
